import { useDetailsShape, handleBeUnitsSet } from '@/lib/billing/utils'
import {
  DetailsVuexState,
  DetailsItemType,
  DetailsState,
  ServiceType,
  SummaryType,
} from '@/@types/billing/details'

const { handleShapeDetailsArray } = useDetailsShape()

const claimState = (): DetailsVuexState => ({
  data: {
    details: [],
    officeNumber: '',
    officeName: '',
    municipalitiesNo: '',
    grantMunicipalNo: '',
    beneficiaryId: '',
    parentsName: '',
    childName: '',
    billingOfficeNumber: '',
    billingOfficeName: '',
    billingAreaClass: '',
    ubUpperLimitMonthlyAmount: '',
    resultNo: '',
    resultCost: '',
    date: '',
    service: [],
    summary: [],
    summaryTotal: {
      batBeUnitsTotal: '',
      batTotalCostTotal: '',
      batUpperLimitMontylyAmountTotal: '',
      batAfterCostTotal: '',
      batAfterUpperLimitCostTotal: '',
      batDecisionUbCostTotal: '',
      batBillingAmountTotal: '',
      batBillingGrantMunicipalTotal: '',
    },
    freeOfCharge: '',
    manyChildrenNo: '',
  },
})

type DetailsStateKeys = keyof DetailsState

type DetailsItemTypeKeys = keyof DetailsItemType
type ServiceTypeKeys = keyof ServiceType
type SummaryTypeKeys = keyof SummaryType

const handleSetCalcBeforeCommonDetailsValue = (
  stateDetailsData: DetailsState
) => {
  handleBeUnitsSet(stateDetailsData)
}

export default {
  namespaced: true,
  state: claimState(),
  mutations: {
    // start -------値セット系
    valueResetSet(state: any) {
      state.data = {}
    },
    valueSet(state: DetailsVuexState, value: DetailsState) {
      state.data = value

      const normalServiceArray = state.data.service.filter(
        (serviceItem: ServiceType) =>
          serviceItem.serviceCodeType === '61' ||
          serviceItem.serviceCodeType === '63'
      )

      const visitServiceArray = state.data.service.filter(
        (serviceItem: ServiceType) => serviceItem.serviceCodeType === '64'
      )

      state.data.service = ([] as ServiceType[]).concat(
        normalServiceArray,
        visitServiceArray
      )

      state.data.details = [
        ...(handleShapeDetailsArray(state.data.details) as DetailsItemType[]),
      ]

      handleSetCalcBeforeCommonDetailsValue(state.data)
    },
    primitiveValueSet(
      state: DetailsVuexState,
      value: {
        key: DetailsStateKeys
        value: any
      }
    ) {
      switch (value.key) {
        case 'ubUpperLimitMonthlyAmount':
          if (value.value === '') value.value = 0

          state.data.summary = state.data.summary.map(
            (summaryItem: SummaryType) => {
              // 再計算時に様式第二の上限額管理後利用者負担額を初期化
              summaryItem.batAfterUpperLimitCost = ''

              // 再計算時に様式第二の調整後利用者負担額を初期化
              summaryItem.batAfterCost = ''

              // 再計算時に様式第二の利用者負担額②を初期化
              summaryItem.batUbCost = ''

              return summaryItem
            }
          )
          break

        case 'resultCost':
          state.data.summary = state.data.summary.map(
            (summaryItem: SummaryType) => {
              summaryItem.batAfterUpperLimitCost = ''

              return summaryItem
            }
          )
          break
      }

      state.data[value.key] = value.value

      handleSetCalcBeforeCommonDetailsValue(state.data)
    },
    valueItemArraySet(
      state: DetailsVuexState,
      value: {
        key: 'details' | 'service' | 'summary'
        updateSubKey:
          | DetailsItemTypeKeys
          | ServiceTypeKeys
          | SummaryTypeKeys
          | undefined
        idx: number
        item: DetailsItemType | ServiceType | SummaryType
      }
    ) {
      state.data[value.key][value.idx] = value.item

      switch (value.updateSubKey) {
        case 'batAfterCost':
        case 'batAfterUpperLimitCost':
          for (let index = 0; index < state.data.summary.length; index++) {
            if (index !== value.idx) {
              state.data.summary[index][value.updateSubKey] = ''
            }
          }
          break
      }

      const tmpArray = JSON.parse(JSON.stringify(state.data[value.key]))

      state.data[value.key].splice(-state.data[value.key].length)

      state.data[value.key].push(...tmpArray)

      handleSetCalcBeforeCommonDetailsValue(state.data)
    },
    // end -------値セット系
    // start -------計算結果後の値セット系
    valueCalculationSet(
      state: DetailsVuexState,
      value: {
        key: DetailsStateKeys
        value: any
      }
    ) {
      state.data[value.key] = value.value
    },
    valueTotalCalculationSet(
      state: DetailsVuexState,
      value: {
        key: DetailsStateKeys
        value: any
      }
    ) {
      state.data[value.key] = value.value

      // 上限管理情報がある場合は管理結果後利用者負担額を格納
      if (state.data.officeNumber) {
        state.data.resultCost = String(
          state.data.summaryTotal.batAfterUpperLimitCostTotal
        )
      }
    },
    // end -------計算結果後の値セット系
    detailsSheetAdd(state: DetailsVuexState) {
      const detailsMax = 12

      for (let i = 0; i < detailsMax; i++) {
        state.data.details.push({
          beServiceContents: '',
          beServiceCode: '',
          beUnits: '',
          beCount: '',
          beServiceUnits: '',
          beDescription: '',
        })
      }
    },
    detailsSheetRemove(
      state: DetailsVuexState,
      sheetInfo: {
        detailsMinItems: number
        detailsMaxItems: number
      }
    ) {
      state.data.details = state.data.details.filter(
        (detailsItem: any, index: number) =>
          !(
            index >= sheetInfo.detailsMinItems &&
            index < sheetInfo.detailsMaxItems
          )
      )

      handleSetCalcBeforeCommonDetailsValue(state.data)
    },
  },
}
